export const getOBCustomerAccountClientModel = (obCustomerAccount) => {
    return {
        id: obCustomerAccount.id,
        obCustomerId: obCustomerAccount.ob_customer_id,
        accountId: obCustomerAccount.account_id,
        data: typeof obCustomerAccount.data === 'string'
            ? JSON.parse(obCustomerAccount.data)
            : obCustomerAccount.data,
        includeBalance: obCustomerAccount.include_balance
    }
};

export const getOBCustomerAccountSubmissionModel = (obCustomerAccount) => {
    return {
        id: obCustomerAccount.id,
        obCustomerId: obCustomerAccount.obCustomerId,
        accountId: obCustomerAccount.accountId,
        data: obCustomerAccount.data,
        includeBalance: obCustomerAccount.includeBalance
    }
};
